import { getConfig } from '@recruiting-solutions/rs-shared';

function getLocale() {
    const csbLocaleValue = document.getElementById('csb-locale')?.getAttribute('lang');
    if (csbLocaleValue) {
        return csbLocaleValue;
    } else {
        const htmlLang = document.getElementsByTagName('html')[0].getAttribute('lang');
        if (htmlLang) {
            return htmlLang.replace('-', '_');
        }
        return null;
    }
}

function getAllTemplateChildren(id: string) {
    let locale = getLocale();
    let template: HTMLTemplateElement | null = null;
    if (locale) {
        template = document.getElementById(id + '-' + locale) as HTMLTemplateElement;
    }
    if (!template) {
        template = document.getElementById(id) as HTMLTemplateElement;
    }

    if (template) {
        if (template.children.length > 0) {
            return Array.from(template.children);
        } else {
            return Array.from(template.content.children);
        }
    } else {
        console.error('Template not found', id);
        return [];
    }
}

function iterate(translations: any, elements: Element[]) {
    elements.forEach(el => {
        const component = el.getAttribute('component');
        const key = el.getAttribute('key');

        let root = translations;

        if (component) {
            translations[component] = translations[component] || {};
            root = translations[component];
        }

        if (key) root[key] = (el as HTMLElement).innerHTML;

        if (el.children.length > 0) {
            iterate(root, Array.from(el.children));
        }
    });
}

/*
// Autogenerate @Prop definition for a component from a template csb-label-group
function _convertToProps(translation: any) {
    const result = [];
    for (const key of Object.keys(translation)) {
        const value = translation[key];
        result.push(`@Prop() ${key}: string = label('${key}', '${value}');`);
    }
    console.log(result.join('\n'));
}
*/

export function readAllTranslations(id: string) {
    const csb = (window as any).csb;
    csb.translations = csb.translations || {};

    if (!csb.translations[id]) {
        const children = getAllTemplateChildren(id) || [];
        const translations: any = {};
        iterate(translations, children);
        //_convertToProps(translations.header);
        csb.translations[id] = translations;
    }

    return csb.translations[id];
}

function getStage() {
    if (window.location.hostname === 'localhost') return 'local';
    if (getConfig().production) return 'prod';
    return 'staging';
}

function resolveStageDependent(value: any) {
    if (value && (value['local'] || value['staging'] || value['prod'])) {
        return value[getStage()];
    }
    return value;
}
/*
 * gets value by component and id
 * set debugI18N=true as query paramater to visually see which translations are missing
 */
export function getTemplateValues(component: string, id = 'csb-language') {
    const translations = readAllTranslations(id);
    return (key: string, fallback = '??? ' + component + ', ' + key) => {
        let value = (translations[component] || {})[key] || translations[key];
        if (!value) console.log('!!!', component, key);
        value = resolveStageDependent(value);
        if (new URL(window.location.href).searchParams.has('debugI18N')) {
            if (new URL(window.location.href).searchParams.get('debugI18N')?.toLowerCase() === 'extended') {
                return component + ':' + key;
            }
            return value || fallback;
        } else {
            return value;
        }
    };
}
